var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-redux/~/lodash/_Symbol.js
// module id = 402
// module chunks = 0